import React from "react";
import { FormattedMessage } from "react-intl";

import * as Yup from "yup";

export const useForgotPasswordValidationSchema = () => {
  const initialValues = {
    email: "",
  };

  const validationSchema = {
    email: Yup.string()
      .email(<FormattedMessage id="YUP_WRONG_EMAIL_ID" />)
      .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
      .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
      .required(<FormattedMessage id="YUP_EMAIL_REQUIRED" />),
  };

  const forgotPasswordValidationSchema = Yup.object().shape(validationSchema);

  return {
    initialValues,
    forgotPasswordValidationSchema,
  };
};
